module.exports = __webpack_public_path__ + "static/media/tickets.80daf6f0.svg";